/**
 * Warning Modifications have been made on top of the base library.
 *
 * @file jQuery UI Datepicker plugin wrapper
 * @note If ≤ IE8 make sure you have a polyfill for Date.toISOString()
 * @param [ui-date] {object} Options to pass to $.fn.datepicker() merged onto uiDateConfig
 */

/*global angular, jQuery, module, exports*/

// commonjs package manager support
if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports){
	module.exports = 'ui.date';
}

(function(angular) {

    'use strict';


	angular
		.module('ui.date', [])
		.constant('uiDateConfig', {})
		.constant('uiDateFormatConfig', '')

		.factory('uiDateConverter', ['uiDateFormatConfig', function(uiDateFormatConfig) {
			return {
				stringToDate: stringToDate,
				dateToString: dateToString,
                shortToIso: shortToIso
			};

			function shortToIso(value) {
			    var dateParts = value.split('/');
			    var year = dateParts[2];
			    var month = dateParts[1];
			    var day = dateParts[0];

			    month = (parseInt(month, 10) < 10) ? '0' + parseInt(month,10) : month;
			    day = (parseInt(day, 10) < 10) ? '0' + parseInt(day, 10) : day;
			    return year + '-' + month + '-' + day;
			}

			function dateToString(dateFormat, value) {
			    dateFormat = dateFormat || uiDateFormatConfig;
				if (value) {
					// HACK This allows for a fix to a bug when the date is being passed through as a string.
				    if (typeof value == 'string') {
				        if (/[0-9]{1,2}\/[0-9]{1,2}\/[0-9]{4}/.test(value)) {
				            var date = moment(shortToIso(value)).format('YYYY-MM-DD');
				            return (date.toLowerCase() !== 'invalid date') ? date : null;
				        }
						return null;
					}

					if (dateFormat) {
						return jQuery.datepicker.formatDate(dateFormat, value);
					}

					if (value.toISOString) {
						return value.toISOString();
					}
				}
				return null;
			}

			function stringToDate(dateFormat, value) {
			    dateFormat = dateFormat || uiDateFormatConfig;

			    if (/[0-9]{1,2}\/[0-9]{1,2}\/[0-9]{4}/.test(value)) {
			        value = shortToIso(value);
			    }

				if (angular.isString(value)) {
					if (dateFormat) {
						try {
							return jQuery.datepicker.parseDate(dateFormat, value);
						}
						catch(e){
							return null;
						}
					}

					var isoDate = new Date(value);
					return isNaN(isoDate.getTime()) ? null : isoDate;
				}
				return null;
			}
		}])

		.directive('uiDate', ['uiDateConfig', 'uiDateConverter', function(uiDateConfig, uiDateConverter) {
			angular.extend({}, uiDateConfig);

			return {
				require: '?ngModel',
				link: function(scope, element, attrs, controller) {
					var getOptions = function() {
						return angular.extend({}, uiDateConfig, scope.$eval(attrs.uiDate));
					};
					var initDateWidget = function() {
						var showing = false;
						var opts    = getOptions();

						function setVal() {
							var keys     = ['Hours', 'Minutes', 'Seconds', 'Milliseconds'];
							var isDate   = false;
							var preserve = {};

							console.log(isDate, controller.$modelValue);
							
							var datepickerDate = moment(element.datepicker('getDate')).hour(0).minute(0).second(0).format('YYYY-MM-DD');
							if( controller.$modelValue == '' && element.datepicker('getDate') != null ) {
								controller.$modelValue = moment(element.datepicker('getDate')).toDate();
							}
							if( /[0-9]{4}-[0-9]{2}-[0-9]{2}/.test(controller.$modelValue) && controller.$modelValue != datepickerDate ) {
								controller.$modelValue = moment(element.datepicker('getDate')).toDate();
							}
							if (/[0-9]{1,2}\/[0-9]{1,2}\/[0-9]{4}/.test(controller.$modelValue)) {
							    controller.$modelValue = moment(uiDateConverter.shortToIso(controller.$modelValue)).toDate();
							}

							
							isDate = angular.isDate(controller.$modelValue);

							
							
							console.log(isDate, controller.$modelValue);
							
							if (isDate && controller.$modelValue.toDateString() === element.datepicker('getDate').toDateString()) {
								return;
							}

							if (isDate) {
								angular.forEach(keys, function(key) {
									preserve[key] = controller.$modelValue['get' + key]();
								});
								controller.$setViewValue(controller.$modelValue);
							}

							if (isDate) {
								angular.forEach(keys, function(key) {
									controller.$viewValue['set' + key](preserve[key]);
								});
							}
						}

						// If we have a controller (i.e. ngModelController) then wire it up
						if (controller) {

							// Set the view value in a $apply block when users selects
							// (calling directive user's function too if provided)
							var _onSelect = opts.onSelect || angular.noop;
							opts.onSelect = function(value, picker) {
								scope.$apply(function() {
									showing = true;
									controller.$setViewValue(value);
									//controller.$modelValue = value;
									setVal();
									_onSelect(value, picker);
									element.blur();
								});
							};

							var _beforeShow = opts.beforeShow || angular.noop;
							opts.beforeShow = function(input, picker) {
								showing = true;
								_beforeShow(input, picker);
							};

							var _onClose = opts.onClose || angular.noop;
							opts.onClose = function(value, picker) {
								showing = false;
								_onClose(value, picker);
							};
							element.off('blur.datepicker').on('blur.datepicker', function() {
								if (!showing) {
									scope.$apply(function() {
										setVal();
									});
								}
							});

							// Update the date picker when the model changes
							controller.$render = function() {
								var date = controller.$modelValue;
								if (angular.isDefined(date) && date !== null && !angular.isDate(date)) {
									if (angular.isString(controller.$modelValue)) {
										date = uiDateConverter.stringToDate(attrs.uiDateFormat, controller.$modelValue);
									} else {
										throw new Error('ng-Model value must be a Date, or a String object with a date formatter - currently it is a ' + typeof date + ' - use ui-date-format to convert it from a string');
									}
								}
								element.datepicker('setDate', date);
							};
						}
						// Check if the element already has a datepicker.
						if (element.data('datepicker')) {
							// Updates the datepicker options
							element.datepicker('option', opts);
							element.datepicker('refresh');
						} else {
							// Creates the new datepicker widget
							element.datepicker(opts);

							//Cleanup on destroy, prevent memory leaking
							element.on('$destroy', function() {
								element.datepicker('hide');
								element.datepicker('destroy');
							});
						}

						if (controller) {
							// Force a render to override whatever is in the input text box
							controller.$render();
						}
					};

					// Watch for changes to the directives options
					scope.$watch(getOptions, initDateWidget, true);
				}
			};
		}])

		.directive('uiDateFormat', ['uiDateConverter', function(uiDateConverter) {
			return {
				require: 'ngModel',
				link: function(scope, element, attrs, modelCtrl) {
					var dateFormat = attrs.uiDateFormat;

					// Use the datepicker with the attribute value as the dateFormat string to convert to and from a string
					modelCtrl.$formatters.unshift(function(value) {
						var result = uiDateConverter.stringToDate(dateFormat, value);
						return (result !== null) ? result : value;
					});

					modelCtrl.$parsers.push(function(value) {
						var result = uiDateConverter.dateToString(dateFormat, value);
						return (result !== null) ? result : value;
					});
				}
			};
		}]);

})(angular);